import { React, useState, useRef, useContext } from 'react';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import digitalAssistantsStyles from '../../DigitalAssistants.module.css';
import Dropdown from 'react-bootstrap/Dropdown';

import { Typeahead, TypeaheadMenu } from 'react-bootstrap-typeahead';
import { useAuth } from 'react-oidc-context';
import { Offcanvas } from 'react-bootstrap';
import SessionExpiredModal from '../../utils/SessionExpiredModal';
import { Box, Button, ButtonBase, Link, ListItemButton } from '@mui/material';
import TransparentButton from '../../utils/TransparentButton';
import TransparentButtonDark from '../../utils/TransparentButtonDark';
import { SnackbarContext } from '../../App';

import Papa from 'papaparse';

import CheckIcon from '@mui/icons-material/Check';

const accountTypes = [
  {
    code: 'xero',
    title: 'XERO',
  },
  {
    code: 'myob',
    title: 'MYOB',
  },
];

export default function UploadClients({ addUserModalShow, closeAddUserModal, users }) {
  const [
    uploadedClients,
    setUploadedClients,
  ] = useState([]);

  const [
    uploadAllowed,
    setUploadAllowed,
  ] = useState(false);

  const [
    contactName,
    setContactName,
  ] = useState('');

  const [
    contactEmail,
    setContactEmail,
  ] = useState('');

  const [
    errorMessage,
    setErrorMessage,
  ] = useState('');

  const [
    autoForwarding,
    setAutoForwarding,
  ] = useState(false);

  const [
    currentStep,
    setCurrentStep,
  ] = useState('Upload');

  const [
    isLoading,
    setIsLoading,
  ] = useState(false);

  const auth = useAuth();

  const { snackBarShow, setSnackBarShow, snackBarMessage, setSnackBarMessage, sessionExpired, setSessionExpired } = useContext(SnackbarContext);

  const abnRef = useRef(null);
  const [
    abnValidity,
    setAbnValidity,
  ] = useState(null);

  function reset() {
    setCurrentStep('Upload');
  }

  function onClose() {
    closeAddUserModal();

    setTimeout(() => {
      reset();
    }, 100);
  }

  const isValidABN = async (abn) => {
    const abnPattern = /^(\d{11})$/;
    return abnPattern.test(abn);
  };

  async function uploadClient() {
    console.log(uploadedClients);

    try {
      const response = await fetch(`${window.origin}/api/client/upload`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth.user?.access_token}`,
        },
        body: JSON.stringify({
          clients: uploadedClients,
        }),
      });
      if (response.status === 403) {
        setSessionExpired(true);
      }
      setSnackBarMessage('Clients uploaded successfully');
      setSnackBarShow(true);
      onClose();
    } catch (e) {
      setSnackBarMessage('Unknown error. Please try again later');
      setSnackBarShow(true);
    }
  }

  function abnCallback(data) {
    // console.log(data)
    return data;
  }

  async function checkABN(abn) {
    const response = await fetch(`https://abr.business.gov.au/json/AbnDetails.aspx?callback=abnCallback&abn=${abn}&guid=4323553b-7eca-4ef2-974d-97c38996e1a9`);

    const data = await response.text();

    let jsonData = eval(data);

    if (jsonData.Message.length !== 0) {
      return false;
    }

    return String(jsonData.EntityName);
  }

  function changeHandler(event) {
    console.log(users);

    if (!event.target.files[0]) {
      setUploadAllowed(false);
      setUploadedClients([]);
      return;
    }
    setUploadAllowed(false);
    setErrorMessage('');
    let count = 2;
    // try{
    Papa.parse(event.target.files[0], {
      header: true,
      skipEmptyLines: true,
      complete: async function (results) {
        try {
          let clients = await Promise.all(results.data.map(async (client) => {

            let assignedToEmails = client['Assigned to'].length == 0 ? [] : client['Assigned to'].replaceAll(' ', '').split(',');

            let assignedTo = users.filter(user => assignedToEmails.includes(user.email));

            let clientName = await checkABN(client['ABN']);

            if (client['ABN'].length == 0) {
              throw Error(`Row ${count} - Please provide ABN`);
            }
            if (!clientName) {
              throw Error(`Row ${count} - Cannot validate client given the provided ABN - client["ABN"]`);
            }

            if (client['Client Name'].length > 0) {
              clientName = client['Client Name'];
            }

            let upperCaseAccountingSoftware = client['Accounting Software'].toUpperCase();
            if (upperCaseAccountingSoftware != 'XERO' && upperCaseAccountingSoftware != 'MYOB' && upperCaseAccountingSoftware != 'NA') {
              throw Error(`Row ${count} - Accounting software must be either XERO or MYOB or NA`);
            }

            if (assignedTo.length < assignedToEmails.length) {
              throw Error(`Row ${count} - At least one email assigned to is not associated with any existing team member`);
            }

            if (client['Auto-forwarding'].toUpperCase() != 'YES' && client['Auto-forwarding'] != 'NO') {
              throw Error(`Row ${count} - Auto-forwardting must be either YES or NO`);
            }

            if (client['Auto-forwarding'].toUpperCase() == 'YES' && (client['Contact Person Name'].length == 0 || client['Contact Person Email'].length == 0)) {
              throw Error(`Row ${count} - Contact Person Name and Email must be provided if Auto-forwarding is YES`);
            }

            count++;
            return {
              clientABN: client['ABN'].replaceAll(' ', ''),
              clientName: clientName,
              contactName: client['Contact Person Name'],
              contactEmail: client['Contact Person Email'],
              autoForwarding: client['Auto-forwarding'].toUpperCase() == 'YES',
              accountingSoftware: upperCaseAccountingSoftware,
              assignedTo: assignedTo,

            };
          }));
          console.log(clients);
          setUploadedClients(clients);
          setUploadAllowed(true);
        } catch (e) {
          setErrorMessage(e.message);
        }
      },
    });
    // }catch(e){
    //     console.log(`Error at row ${count}`)
    //     console.log(e)
    // }
  }

  return (
    <>
      <Modal
        show={addUserModalShow}
        onHide={onClose}
        dialogClassName="modal-70w"
        aria-labelledby="example-custom-modal-styling-title"
      >

        <Modal.Body style={{ padding: '2vw 3vw', textAlign: 'center', color: 'rgb(0, 15, 30, 0.8)' }}>

          <h4 style={{ textAlign: 'center', fontSize: '1.3vw', marginBottom: '1vw', fontWeight: '500', color: 'rgb(0, 15, 30, 0.8)' }}>Upload Bulk Clients</h4>

          {/* {isLoading && <CircularProgress  style={{marginBottom: '1vw', color: 'white'}}/>} */}

          <div style={{ display: currentStep == 'Upload' ? 'block' : 'none' }}>
            <p style={{ margin: 0, marginBottom: '2.5vw', fontWeight: '300', fontSize: '0.8vw', padding: '0 2vw', color: 'rgb(0, 15, 30, 0.8)' }}>Please complete the steps before click continue</p>

            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <div style={{ flex: 1, backgroundColor: 'rgb(255, 255, 255, 0.5)', padding: '1vw', borderRadius: '0.8vw', marginBottom: '1vw' }}>
                <p style={{ fontSize: '1vw', marginBottom: '1vw' }}>Step 1</p>
                <p style={{ fontSize: '0.8vw', marginBottom: '1vw' }}>Download and fill in the template below</p>
                <Link href={require('../../resources/SharedClientTemplate.csv')} download="ClientTemplate.csv" style={{ fontSize: '0.8vw', marginBottom: '1vw', color: '#1c6c6c', cursor: 'pointer' }} underline="always">
                  Download Template
                </Link>

              </div>

              <div style={{ flex: 1, backgroundColor: 'rgb(255, 255, 255, 0.5)', padding: '1vw', borderRadius: '0.8vw', marginBottom: '1vw' }}>
                <p style={{ fontSize: '1vw', marginBottom: '1vw' }}>Step 2</p>
                <p style={{ fontSize: '0.8vw', marginBottom: '1vw' }}>Upload the filled-in template</p>
                <div className="">

                  <div className="form-group files">
                    <input type="file" className="form-control" onChange={changeHandler} multiple="" accept=".csv" />
                  </div>

                </div>

              </div>
              <p style={{ marginBottom: '1vw', color: 'red' }}>{errorMessage}</p>
            </div>

            <Button
              onClick={() => {
                if (!uploadAllowed) {
                  setSnackBarMessage('Please ensure the file is uploaded successfully before continue');
                  setSnackBarShow(true);
                  return;
                }

                setCurrentStep('Verify');
              }}
              variant="outlined"
              style={{
                borderColor: 'rgb(255, 255, 255, 1)', color: 'rgb(255, 255, 255, 0.9)', padding: '0.7vw 8vw', marginBottom: '1vw', border: 'none', backgroundImage: 'linear-gradient(rgb(255, 255, 255, 0.05), rgb(10, 10, 10, 0.05)),linear-gradient(#1c6c6c, #1c6c6c)', borderRadius: '0.5vw', textTransform: 'none', fontSize: '1vw', fontWeight: 500, letterSpacing: '0.08vw',
                marginTop: '1vw' }}
            >
              Next
            </Button>
          </div>

          <div style={{ display: currentStep == 'Verify' ? 'block' : 'none', textAlign: 'center' }}>
            <p style={{ margin: 0, marginBottom: '2.5vw', fontWeight: '300', fontSize: '0.8vw', padding: '0 2vw', color: 'rgb(0, 15, 30, 0.8)' }}>Prease verify the details are correct</p>

            <div style={{ backgroundColor: 'rgb(255, 255, 255, 0.4)', borderRadius: '1vw', overflow: 'hidden', marginBottom: '3vw' }}>
              <ListItemButton style={{ backgroundColor: 'rgb(0, 0, 0, 0)' }}>
                <div style={{ display: 'flex', flexDirection: 'row', width: '100%', textAlign: 'left' }}>
                  <div style={{ flex: 2, fontSize: '0.8vw', fontWeight: '500', marginLeft: '1vw' }}>Client</div>
                  <div style={{ flex: 1.5, fontSize: '0.8vw', fontWeight: '500' }}>Contact</div>
                  <div style={{ flex: 1, fontSize: '0.8vw', fontWeight: '500' }}>Forwarding</div>
                  <div style={{ flex: 1, fontSize: '0.8vw', fontWeight: '500' }}>Software</div>

                  <div style={{ flex: 1, fontSize: '0.8vw', fontWeight: '500' }}>Assigned to</div>
                </div>
              </ListItemButton>

              <Box
                style={{ width: '100%' }}
                sx={{ width: '100%', maxHeight: '20vw', width: '100%', bgcolor: 'rgb(0, 0, 0, 0)', overflowY: 'scroll' }}
              >

                {uploadedClients.map(client => (
                  <ListItemButton style={{ backgroundColor: 'rgb(255, 255, 255, 0.5)', width: '100%' }}>
                    <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
                      <div style={{ flex: 2, fontSize: '0.8vw', fontWeight: '500', marginLeft: '1vw' }}>
                        <p style={{ marginBottom: '0.2vw' }}>{client.clientName}</p>
                        <p style={{ marginBottom: '0.2vw', fontSize: '0.7vw', color: 'rgb(0, 0, 0, 0.5)' }}>{client.clientABN}</p>
                      </div>
                      <div style={{ flex: 1.5, fontSize: '0.8vw', fontWeight: '500' }}>
                        <p style={{ marginBottom: '0.2vw' }}>{client.contactName}</p>
                        <p style={{ marginBottom: '0.2vw', fontSize: '0.7vw', color: 'rgb(0, 0, 0, 0.5)' }}>{client.contactEmail}</p>
                      </div>
                      <div style={{ flex: 1, fontSize: '0.8vw', fontWeight: '500' }}>{client.autoForwarding ? 'Yes' : 'No'}</div>

                      <div style={{ flex: 1, fontSize: '0.8vw', fontWeight: '500' }}>{client.accountingSoftware}</div>

                      <div style={{ flex: 1, fontSize: '0.8vw', fontWeight: '500' }}>
                        {client.assignedTo.length}
                        {' '}
                        users
                      </div>
                    </div>
                  </ListItemButton>
                ))}
              </Box>
            </div>

            <Button
              onClick={uploadClient}
              variant="outlined"
              style={{ display: 'block',
                borderColor: 'rgb(255, 255, 255, 1)', color: 'rgb(255, 255, 255, 0.9)', padding: '0.7vw 8vw ', marginBottom: '0', border: 'none', backgroundImage: 'linear-gradient(rgb(255, 255, 255, 0.05), rgb(10, 10, 10, 0.05)),linear-gradient(#1c6c6c, #1c6c6c)', borderRadius: '0.5vw', textTransform: 'none', fontSize: '1vw', fontWeight: 500, letterSpacing: '0.08vw',
                width: '40%', marginTop: '1vw', marginLeft: 'auto', marginRight: 'auto' }}
            >
              Upload
            </Button>

            <Button
              onClick={() => { setCurrentStep('Upload'); }}
              variant="outlined"
              style={{ display: 'block',
                borderColor: 'rgb(255, 255, 255, 1)', color: '#1c6c6c', padding: '0.3vw 0.5vw', border: 'none', backgroundColor: 'rgb(255, 255, 255, 0)', borderRadius: '0.5vw', textTransform: 'none', fontSize: '0.9vw', fontWeight: 500, letterSpacing: '0.08vw',
                marginTop: '1vw', marginLeft: 'auto', marginRight: 'auto' }}
            >
              Previous
            </Button>
          </div>

          {currentStep == 'Permission' && (
            <div>
              <p style={{ margin: 0, marginBottom: '2.5vw', fontWeight: '300', fontSize: '0.8vw', padding: '0 2vw', color: 'rgb(0, 15, 30, 0.8)' }}>Select all the users that will have access to this client</p>

              <Button
                variant="outlined"
                style={{
                  borderColor: 'rgb(255, 255, 255, 1)', color: 'rgb(255, 255, 255, 0.9)', padding: '0.7vw', marginBottom: '0', border: 'none', backgroundImage: 'linear-gradient(rgb(255, 255, 255, 0.05), rgb(10, 10, 10, 0.05)),linear-gradient(#1c6c6c, #1c6c6c)', borderRadius: '0.5vw', textTransform: 'none', fontSize: '1vw', fontWeight: 500, letterSpacing: '0.08vw',
                  width: '100%', marginTop: '1vw' }}
              >
                Confirm
              </Button>

              <Button
                onClick={() => { setCurrentStep('Communication'); }}
                variant="outlined"
                style={{
                  borderColor: 'rgb(255, 255, 255, 1)', color: 'rgb(0, 0, 0, 0.9)', padding: '0.7vw', marginBottom: '1vw', border: 'none', backgroundColor: 'rgb(255, 255, 255, 0.5)', borderRadius: '0.5vw', textTransform: 'none', fontSize: '1vw', fontWeight: 500, letterSpacing: '0.08vw',
                  width: '100%', marginTop: '1vw' }}
              >
                Previous
              </Button>
            </div>
          )}

        </Modal.Body>
      </Modal>

    </>
  );
}
